import {time} from "@atttomyx/shared-constants";

export const app = {
    name: "The Inventors Arena",
    description: "Where inventors and investors meet",
    namespace: "courses",
    baseUrl: "https://courses-app-lw4r26jkhq-uc.a.run.app",
    timeout: time.SECONDS_IN_MINUTE * time.MILLISECONDS_IN_SECOND,
    retries: 3,
    accountId: "iV5S8ppY03j9wpddUq3c",
    cloudinaryId: "cuteandfuzzy",
};
